export default __webpack_public_path__ + "static/s4-093d485caf04c952ab471304cd0c0490.png";